import { formatCentsToUSD, formatStringToCents } from '@go-shared/lib/utils';
import React, { useEffect, useRef, useState } from 'react';
import BubbleInput, { BubbleInputProps } from './BubbleInput';

export type BubbleCurrencyProps = Omit<
  BubbleInputProps,
  'formik' | 'type' | 'value' | 'onValue'
> & {
  value: number | undefined; // value in cents
  onValue?: (value: number | undefined) => void;
};

export default function BubbleCurrency(props: BubbleCurrencyProps) {
  const {
    value: numberValue,
    onValue: onNumberValue,
    onBlur: propsOnBlur,
    onChange: propsOnChange,
    ...rest
  } = props;

  const internalChangeRef = useRef(false);
  const [textValue, setTextValue] = useState(() => formatCentsToUSD(numberValue));

  useEffect(() => {
    if (internalChangeRef.current) {
      internalChangeRef.current = false;
      return;
    }
    setTextValue(formatCentsToUSD(numberValue));
  }, [numberValue]);

  function handleOnBlur(evt: React.FocusEvent<HTMLInputElement>) {
    // Convert textValue (formatted string) back to number (in cents)
    const centsValue = formatStringToCents(textValue);
    setTextValue(formatCentsToUSD(centsValue));
    propsOnBlur?.(evt);
  }

  function handleOnChange(evt: React.ChangeEvent<HTMLInputElement>) {
    const centsValue = formatStringToCents(evt.target.value);
    evt.target.value = centsValue?.toString() ?? '';
    propsOnChange?.(evt);
  }

  function handleOnValue(value: string) {
    internalChangeRef.current = true;
    setTextValue(value);
    const centsValue = formatStringToCents(value);
    onNumberValue?.(centsValue);
  }

  return (
    <BubbleInput
      type="text"
      value={textValue}
      onValue={handleOnValue}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      {...rest}
    />
  );
}
